export const MINUTE_IN_MS = 1000 * 60
